<h2><a  [ngClass]="{'translated':article.translated===false}"
   [queryParams]="article?.kicker || article?. title || article?.number ? {book_title:article.number ? article.number  : article.kicker} : {}"
    routerLink="/rulebook/article/{{ article?.id }}">{{ article?.number }} {{ article?.kicker }} {{ article?.title
    }}</a></h2>
<div [ngClass]="{'translated':article.translated===false}" [innerHTML]="article?.text | highlight: higlight"></div>
